<template>
  <div>
    <CRow>
      <CCol lg="12">
        <!-- <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="items"
          :editButton="true"
          :redirectDetail="true"
          :isLoading="isLoading"
          @addForm="addForm"
        ></GlobalTable> -->

        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="6">
              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Nama Freezer"
                    invalid-feedback="Nama Freezer should be filled"
                    required
                    v-model="$v.freezerForm.name.$model"
                    :is-valid="!$v.freezerForm.name.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <div class="form-group">
                    <label for="freezer_owner">Freezer Owner</label>
                    <model-select
                      class="form-control"
                      id="freezer_owner"
                      :options="freezerOwnerList"
                      v-model="$v.freezerForm.freezer_owner_code.$model"
                      :isError="$v.freezerForm.freezer_owner_code.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.freezerForm.freezer_owner_code.$invalid"
                      class="invalid-feedback-custom"
                    >Freezer Owner should be filled.</div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Brand"
                    invalid-feedback="Brand should be filled"
                    v-model="$v.freezerForm.brand.$model"
                    :is-valid="!$v.freezerForm.brand.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CTextarea
                    label="SKU"
                    invalid-feedback="SKU should be filled"
                    v-model="$v.freezerForm.sku.$model"
                    :is-valid="!$v.freezerForm.sku.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Capacity"
                    min="0"
                    invalid-feedback="Capacity should be filled"
                    required
                    v-model="$v.freezerForm.capacity.$model"
                    :is-valid="!$v.freezerForm.capacity.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Weight"
                    min="0"
                    invalid-feedback="Weight should be filled"
                    required
                    v-model="$v.freezerForm.weight.$model"
                    :is-valid="!$v.freezerForm.weight.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Voltage"
                    min="0"
                    invalid-feedback="Voltage should be filled"
                    required
                    v-model="$v.freezerForm.voltage.$model"
                    :is-valid="!$v.freezerForm.voltage.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Dimension"
                    min="0"
                    invalid-feedback="Dimension should be filled"
                    required
                    v-model="$v.freezerForm.dimention.$model"
                    :is-valid="!$v.freezerForm.dimention.$invalid"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Max Slot For Rent"
                    min="0"
                    invalid-feedback="Slot For Rent should be filled"
                    required
                    v-model="$v.freezerForm.slot.$model"
                    :is-valid="!$v.freezerForm.slot.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    label="Image Information"
                    invalid-feedback="Brand should be filled"
                    v-model="$v.freezerForm.image_information.$model"
                    :is-valid="!$v.freezerForm.image_information.$invalid"
                  />
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="6">
              <CRow>
                <CCol sm="12">
                  <label for="nik">Description</label>
                  <quill-editor
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.freezerForm.description.$model"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.freezerForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.freezerForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Freezers",
  components: { Loading, quillEditor, TableButton, JqxGrid },
  data() {
    return {
      title: "Freezers",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "freezer_code", type: "string" },
          { name: "freezer_owner_code", type: "string" },
          { name: "name", type: "string" },
          { name: "brand", type: "string" },
          { name: "sku", type: "string" },
          { name: "capacity", type: "string" },
          { name: "weight", type: "string" },
          { name: "voltage", type: "string" },
          { name: "dimention", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,
      fields: [
        {
          datafield: "freezer_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Freezer",
        },
        {
          datafield: "freezer_owner_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Pemilik Freezer",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Freezer",
        },
        {
          datafield: "brand",
          columntype: "textbox",
          filtertype: "textbox",
          width:150,
          text: "Brand",
        },
        {
          datafield: "sku",
          columntype: "textbox",
          filtertype: "textbox",
          width:100,
          text: "SKU",
        },
         {
          datafield: "capacity",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kapasitas",
        },
        {
          datafield: "weight",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Berat",
        },
        {
          datafield: "voltage",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Voltage",
        },
        {
          datafield: "dimention",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Dimensi",
        },
        {
          datafield: "slot",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Slot",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],
      listBoxSource: [
        {
          label: "Voltage",
          value: "voltage",
          checked: true,
        },
        {
          label: "Dimensi",
          value: "dimention",
          checked: true,
        },
        {
          label: "Deskripsi",
          value: "description",
          checked: true,
        },
      ],
      freezerForm: tableInterfaces.freezers,
      items: null,
      parentCategoryList: [],
      categoryList: [],
      groupList: [],
      agentList: [],
      statusList: [],
      tempParentCategoryList: [],
      tempCategoryList: [],
      freezerUnitList: [],
      freezerOwnerList: [],
      isLoading: false,
      isEdit: false,
      addButton: false,
      content: "",
      editorOption: {}, // data quill
      filter: {
        agent: null,
        status: null,
      },
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    freezerForm: {
      name: { required },
      brand: { required },
      freezer_owner_code: { required },
      sku: { required },
      capacity: { required },
      weight: { required },
      voltage: { required },
      slot: { required },
      dimention: { required },
      description: { required },
      image_information: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    is_agent: function () {
      const agent = localStorage.getItem("is_agent");
      return agent === "true" ? true : false;
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getDropdown();
      this.getFreezerListing();
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/freezer_owner").then((response) => {
        this.freezerOwnerList = response.data.data;
      });
    },
    getFreezerListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/freezer/all")
        .then((response)=>{
          if(response.data.status === 2000){
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          }else{
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.freezerForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.freezers) {
        tableInterfaces.freezers[i] = null;
      }
      this.freezerForm = tableInterfaces.freezers;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this freezer ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/freezer/add", this.freezerForm)
          .then((response) => {

            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });

            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    searching: function () {
      this.getFreezerListing(this.filter);
    },
    clearFilter: function () {
      this.filter = {
        agent: null,
        status: null,
      };
      this.getFreezerListing(this.filter);
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.freezerForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
